import React, { useState, useRef, useEffect } from 'react';

const PremiumTimePicker = ({ value, onChange, label = 'Time' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropRef = useRef(null);

    // Default to empty or parse HH:mm
    const [hour, setHour] = useState('');
    const [minute, setMinute] = useState('');

    useEffect(() => {
        if (value && value.includes(':')) {
            const [h, m] = value.split(':');
            setHour(h);
            setMinute(m);
        } else {
            setHour('');
            setMinute('');
        }
    }, [value]);

    useEffect(() => {
        const handler = (e) => {
            if (dropRef.current && !dropRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const hours = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
    const minutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

    const handleSelect = (type, val) => {
        let newH = hour;
        let newM = minute;
        if (type === 'h') newH = val;
        if (type === 'm') newM = val;
        
        // Auto default minute if not set
        if (type === 'h' && !newM) newM = '00';
        if (type === 'm' && !newH) newH = '08'; // Default morning hour if minute picked first
        
        setHour(newH);
        setMinute(newM);
        
        if (newH && newM) {
            onChange(`${newH}:${newM}`);
            if (type === 'm') setIsOpen(false);
        }
    };

    return (
        <div className="relative" ref={dropRef}>
            <button
                type="button"
                onClick={() => setIsOpen(v => !v)}
                className={`w-full px-5 py-3.5 rounded-2xl bg-white dark:bg-slate-800 border ${isOpen ? 'border-indigo-500' : 'border-slate-200 dark:border-slate-700'} text-left flex items-center justify-between gap-3 focus:outline-none transition-all font-medium`}
            >
                <span className={hour && minute ? 'text-indigo-600 dark:text-indigo-400 font-bold tracking-widest' : 'text-slate-400'}>
                    {hour && minute ? `${hour}:${minute}` : '-- : --'}
                </span>
                <svg className="w-5 h-5 text-slate-400 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            </button>
            
            {isOpen && (
                <div className="absolute z-50 top-full mt-2 left-0 right-0 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl shadow-2xl overflow-hidden animate-in fade-in slide-in-from-top-2 duration-150 p-2 flex gap-2">
                    {/* Hours */}
                    <div className="flex-1 bg-slate-50 dark:bg-slate-900/50 rounded-xl overflow-hidden flex flex-col">
                        <div className="text-[9px] font-black uppercase tracking-widest text-slate-400 text-center py-2 border-b border-slate-200 dark:border-slate-700">Hour</div>
                        <div className="h-48 overflow-y-auto custom-scrollbar p-1">
                            {hours.map(h => (
                                <button key={h} type="button" onClick={() => handleSelect('h', h)}
                                    className={`w-full py-2 text-sm font-bold rounded-lg transition-colors ${hour === h ? 'bg-indigo-500 text-white shadow-md' : 'text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700'}`}>
                                    {h}
                                </button>
                            ))}
                        </div>
                    </div>
                    {/* Minutes */}
                    <div className="flex-1 bg-slate-50 dark:bg-slate-900/50 rounded-xl overflow-hidden flex flex-col">
                        <div className="text-[9px] font-black uppercase tracking-widest text-slate-400 text-center py-2 border-b border-slate-200 dark:border-slate-700">Min</div>
                        <div className="h-48 overflow-y-auto custom-scrollbar p-1">
                            {minutes.map(m => (
                                <button key={m} type="button" onClick={() => handleSelect('m', m)}
                                    className={`w-full py-2 text-sm font-bold rounded-lg transition-colors ${minute === m ? 'bg-indigo-500 text-white shadow-md' : 'text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700'}`}>
                                    {m}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PremiumTimePicker;
